export const isLoaderDisplayed = state => !state.isShopLoaded && state.isShopLoading
